// istanbul ignore file

// TODO: Remove this. Why are there two?!
export type LeaseOccupant = {
    id: number;
    name: string;
    email: string;
};

// TODO: Remove this
// eslint-disable-next-line @typescript-eslint/naming-convention
export type REMOVE_PropertyTenancy = {
    id: number | null;
    startDate: string | null | undefined;
    endDate: string | null | undefined;
    vacateDate: string | null | undefined;
    occupants: Occupant[];
};

// TODO: Remove this second definition
export type Occupant = {
    complianceOccupantId: number;
    mobile: string;
    name: string;
    email?: string;
    mobileContacts: string[];
};

export type TenancyDetail = {
    currentTenancy: REMOVE_PropertyTenancy;
    upcomingTenancy: REMOVE_PropertyTenancy;
    isVacant: boolean;
};

export enum TenancyStatus {
    Active = 'ACTIVE',
    Upcoming = 'UPCOMING',
    AllUpcoming = 'ALL_UPCOMING',
    Previous = 'PREVIOUS'
}

export enum ContactNumberType {
    Mobile = 'MOBILE',
    Home = 'HOME',
    Office = 'OFFICE',
    Other = 'OTHER'
}

export function getReadableContactNumberType(
    type: ContactNumberType | null
): string {
    switch (type) {
        case ContactNumberType.Mobile:
            return 'Mobile';
        case ContactNumberType.Home:
            return 'Home';
        case ContactNumberType.Office:
            return 'Office';
        case ContactNumberType.Other:
            return 'Other';
        default:
            return 'Other';
    }
}

export enum LeaseType {
    New = 'NEW',
    Renewal = 'RENEWAL'
}

export function getReadableLeaseType(type: LeaseType): string {
    switch (type) {
        case LeaseType.New:
            return 'New';
        case LeaseType.Renewal:
            return 'Renewal';
        default:
            return 'Unknown';
    }
}

export enum Source {
    Manual = 'MANUAL'
}

export function getReadableSource(source: Source) {
    switch (source) {
        case Source.Manual:
            return 'Manually entered';
        default:
            return source;
    }
}

export type ContactNumber = {
    contactNumberId?: number | undefined;
    number: string | null;
    type: ContactNumberType | null;
    notAllowedToContact: boolean;
    doNotContactReasonNotes: string | null;
    doNotContactReasonName: string | null;
    doNotContactReasonCode: string | null;
};

export type OccupantContact = {
    occupantId?: number | null;
    name: string | null;
    email: string | null;
    contactNumbers: ContactNumber[];
    isAllContactNumbersBlacklisted: boolean;
};

export type TenancyOccupant = {
    name: string;
    email: string | null;
    contactNumbers: {
        number: string;
        type: ContactNumberType | null;
    }[];
};

export type Tenancy = {
    tenancyId: number;
    leaseType: LeaseType | null;
    status: TenancyStatus;
    startedAt: Date;
    endedAt: Date;
    vacatingAt: Date;
    renewalDate: Date | null;
    occupants: OccupantContact[];
    notes: string;
    source: Source;
};

export type PropertyTenancies = {
    active: Tenancy | null;
    allUpcoming: Tenancy[];
    previous: Tenancy[];
};
